import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { DeleteWarningIcon } from '../ui/icons';
import { useDeleteDeviceModal } from './useDeleteDeviceModal';

interface IProps {
  deviceId: string;
  deviceDisplayName: string
}

const DeleteDeviceModal = (props: IProps) => {
  const { deviceId, deviceDisplayName } = props;
  const { handleDeleteButtonClick, showModel, handleClose, handleShow } = useDeleteDeviceModal(deviceId);


  return (
    <>
      <div onClick={handleShow}>
        Delete
      </div>

      <Modal show={showModel} onHide={handleClose} className='modal-container' centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className='delete-heading'>
              <DeleteWarningIcon></DeleteWarningIcon>
              <h1>Delete</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete {deviceDisplayName}?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn-cancel' onClick={handleClose}>
            Cancel
          </Button>
          <Button className='btn-delete' onClick={handleDeleteButtonClick}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeleteDeviceModal;